import { useEffect } from "react";

import { isStaging } from "../../constants/env";

const GAMBOT_SCRIPT_SELECTOR = 'script[data-gambot-key="pk_gambot_JbxGjlNtSqRmzP0SXWrOU5ULtpHUVYxu1QuEaFVyTHA"]';

const GambotWidget = () => {
  useEffect(() => {
    if (!isStaging || document.querySelector(GAMBOT_SCRIPT_SELECTOR)) {
      return;
    }

    const script = document.createElement("script");
    script.src = "https://fdmweb.co.uk/static/gambot/widget.js";
    script.async = true;
    script.setAttribute("data-gambot-key", "pk_gambot_JbxGjlNtSqRmzP0SXWrOU5ULtpHUVYxu1QuEaFVyTHA");
    script.setAttribute("data-gambot-base", "https://fdmweb.co.uk");
    script.setAttribute("data-gambot-position", "bottom-right");
    script.setAttribute("data-gambot-accent-color", "#D8845B");
    script.setAttribute("data-gambot-pill-text", "#0f172a");

    document.body.appendChild(script);
  }, []);

  return null;
};

export default GambotWidget;
